import EffectMod from "@/roc/effects/EffectMod";
import { Calc } from "@/roc/effects/EffectAmount";
class HappinessMod extends EffectMod {
    constructor(amount, index) {
        super(Calc.flat, amount, index);
    }
    apply(value) {
        return value + this.__amount;
    }
}
export default HappinessMod;
